"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.BackgroundContainer = styled_components_1.default(function (_a) {
  var height = _a.height,
      backgroundColor = _a.backgroundColor,
      activeBreakpoint = _a.activeBreakpoint,
      position = _a.position,
      shouldExpand = _a.shouldExpand,
      onLayoutHandler = _a.onLayoutHandler,
      rest = __rest(_a, ["height", "backgroundColor", "activeBreakpoint", "position", "shouldExpand", "onLayoutHandler"]);

  return react_1.default.createElement(react_native_1.View, __assign({
    onLayout: onLayoutHandler
  }, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    flex-direction: column;\n    display: flex;\n    ", "\n"], ["\n    width: 100%;\n    flex-direction: column;\n    display: flex;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      position = _a.position,
      backgroundColor = _a.backgroundColor,
      theme = _a.theme,
      shouldExpand = _a.shouldExpand;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            " + (shouldExpand ? 'min-height: 100vh;' : '') + "\n            position: " + (position ? position : 'absolute') + ";\n            padding: " + (small ? core_1.GutterSizeEnum.small : core_1.GutterSizeEnum.wide) + "px;\n            background-color: " + setBackgroundColor(backgroundColor, theme, activeBreakpoint) + ";\n        ";
});

function setBackgroundColor(backgroundColor, theme, activeBreakpoint) {
  if (responsive_1.isSmall(activeBreakpoint)) {
    return theme.colors.white;
  }

  return backgroundColor ? backgroundColor : theme.colors.white;
}

exports.TopLeftContainer = styled_components_1.default(react_native_1.Image)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: 0px;\n    left: 0;\n    max-width: 390px;\n    max-height: 143px;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n"], ["\n    position: absolute;\n    top: 0px;\n    left: 0;\n    max-width: 390px;\n    max-height: 143px;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n"])), function (props) {
  return props.width * 0.57;
}, function (props) {
  return props.width * (0.57 / 2.73);
});
exports.TopRightContainer = styled_components_1.default(react_native_1.Image)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: 0px;\n    right: 0;\n    max-width: 496px;\n    max-height: 694px;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n"], ["\n    position: absolute;\n    top: 0px;\n    right: 0;\n    max-width: 496px;\n    max-height: 694px;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n"])), function (_a) {
  var width = _a.width;
  return width * 0.36;
}, function (_a) {
  var width = _a.width;
  return width * (0.36 / 0.71);
});
exports.BottomLeftContainer = styled_components_1.default(react_native_1.Image)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0px;\n    left: 0;\n    max-width: 336px;\n    max-height: 256px;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n"], ["\n    position: absolute;\n    bottom: 0px;\n    left: 0;\n    max-width: 336px;\n    max-height: 256px;\n    width: ", "px;\n    height: ", "px;\n    z-index: 0;\n"])), function (props) {
  return props.width * 0.25;
}, function (props) {
  return props.width * (0.25 / 1.31);
});
exports.BottomRightContainerBase = styled_components_1.default(react_native_1.Image)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0px;\n    right: 0;\n    z-index: 1;\n"], ["\n    position: absolute;\n    bottom: 0px;\n    right: 0;\n    z-index: 1;\n"])));
exports.BottomRightContainer = styled_components_1.default(exports.BottomRightContainerBase)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    max-width: 303px;\n    max-height: 76px;\n    width: ", "px;\n    height: ", "px;\n"], ["\n    max-width: 303px;\n    max-height: 76px;\n    width: ", "px;\n    height: ", "px;\n"])), function (props) {
  return props.width * 0.3;
}, function (props) {
  return props.width * (0.3 / 3.99);
});
exports.BottomRightContainerWithStaticSizes = styled_components_1.default(exports.BottomRightContainerBase)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n"], ["\n    width: ", "px;\n    height: ", "px;\n"])), function (_a) {
  var width = _a.width;
  return width;
}, function (_a) {
  var height = _a.height;
  return height;
}); // todo duplicated component!

exports.AllRightsReservedContainer = styled_components_1.default(react_native_1.View)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 32px;\n    left: 32px;\n    z-index: 1;\n    font-size: 14px;\n    color: ", ";\n"], ["\n    position: absolute;\n    bottom: 32px;\n    left: 32px;\n    z-index: 1;\n    font-size: 14px;\n    color: ", ";\n"])), function (props) {
  return props.theme.colors.title;
});
exports.BottomLeftFullContainer = styled_components_1.default(react_native_1.Image)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0px;\n    left: 0;\n    z-index: 0;\n    height: ", "px;\n    max-height: 100%;\n    width: ", "px;\n    max-width: ", "px;\n"], ["\n    position: absolute;\n    bottom: 0px;\n    left: 0;\n    z-index: 0;\n    height: ", "px;\n    max-height: 100%;\n    width: ", "px;\n    max-width: ", "px;\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.height * 0.47;
}, function (props) {
  return props.height * 0.47 * 1.2;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;